'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const OneToOneSupportIcon = ({ sx }) => {
  return (
    <SvgIcon sx={sx} data-testid="OneToOneSupportIcon">
      <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_276_2431)">
          <path
            d="M8 23.5L8.5 17.5H11V14C11 12.6739 10.4732 11.4021 9.53553 10.4645C8.59785 9.52678 7.32608 9 6 9C4.67392 9 3.40215 9.52678 2.46447 10.4645C1.52678 11.4021 1 12.6739 1 14V17.5H3.5L4 23.5H8Z"
            stroke={sx?.color || '#3D517B'}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M6 7.5C7.933 7.5 9.5 5.933 9.5 4C9.5 2.067 7.933 0.5 6 0.5C4.067 0.5 2.5 2.067 2.5 4C2.5 5.933 4.067 7.5 6 7.5Z"
            stroke={sx?.color || '#3D517B'}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M17.9389 10.37C17.2093 9.6793 16.2888 9.22408 15.297 9.06357C14.3052 8.90306 13.2881 9.04469 12.3779 9.47003"
            stroke={sx?.color || '#3D517B'}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M14.5 7.5C16.1569 7.5 17.5 6.15685 17.5 4.5C17.5 2.84315 16.1569 1.5 14.5 1.5C12.8431 1.5 11.5 2.84315 11.5 4.5C11.5 6.15685 12.8431 7.5 14.5 7.5Z"
            stroke={sx?.color || '#3D517B'}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M19 23.5C21.7614 23.5 24 21.2614 24 18.5C24 15.7386 21.7614 13.5 19 13.5C16.2386 13.5 14 15.7386 14 18.5C14 21.2614 16.2386 23.5 19 23.5Z"
            stroke={sx?.color || '#3D517B'}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M17.5 17.5C17.5 17.2033 17.588 16.9133 17.7528 16.6666C17.9176 16.42 18.1519 16.2277 18.426 16.1142C18.7001 16.0007 19.0017 15.9709 19.2926 16.0288C19.5836 16.0867 19.8509 16.2296 20.0607 16.4393C20.2704 16.6491 20.4133 16.9164 20.4712 17.2074C20.5291 17.4983 20.4993 17.7999 20.3858 18.074C20.2723 18.3481 20.08 18.5824 19.8334 18.7472C19.5867 18.912 19.2967 19 19 19"
            stroke={sx?.color || '#3D517B'}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M19 21.25C18.8619 21.25 18.75 21.1381 18.75 21C18.75 20.8619 18.8619 20.75 19 20.75"
            stroke={sx?.color || '#3D517B'}
          />
          <path
            d="M19 21.25C19.1381 21.25 19.25 21.1381 19.25 21C19.25 20.8619 19.1381 20.75 19 20.75"
            stroke={sx?.color || '#3D517B'}
          />
        </g>
        <defs>
          <clipPath id="clip0_276_2431">
            <rect width="24" height="24" fill="white" transform="translate(0.5)" />
          </clipPath>
        </defs>
      </svg>
    </SvgIcon>
  )
}

OneToOneSupportIcon.propTypes = {
  sx: PropTypes.object
}
